import React from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";

/* eslint-disable react/prop-types */
const transactionColumns = [
  { Header: "Transaction Date", accessor: "createdAt", align: "left", Cell: ({ value }) => value ?? "-" },
  { Header: "Counter ID", accessor: "counterId", align: "left", Cell: ({ value }) => value ?? "-" },
  { Header: "Device SN", accessor: "deviceSn", align: "left", Cell: ({ value }) => value ?? "-" },
  { Header: "Amount", accessor: "originalAmount", align: "left", Cell: ({ value }) => value ?? "-" },
  { Header: "Settlement Amount", accessor: "merchantSettlementAmount", align: "left", Cell: ({ value }) => value ?? "-" },
  { Header: "DMS Commission", accessor: "dmsCommAmount", align: "left", Cell: ({ value }) => value ?? "-" },
  { Header: "Bank Commission", accessor: "bankCommAmount", align: "left", Cell: ({ value }) => value ?? "-" },
  { Header: "Merchant Transaction ID", accessor: "merchantTransactionId", align: "left", Cell: ({ value }) => value ?? "-" },
  { Header: "QR Status", accessor: "status", align: "left", Cell: ({ value }) => value ?? "-" },
  { Header: "Pay Status", accessor: "payStatus", align: "left", Cell: ({ value }) => value ?? "-" },
  { Header: "Settlement Status", accessor: "settlementStatus", align: "left", Cell: ({ value }) => value ?? "-" },
  { 
    Header: "Message", 
    accessor: "message", 
    align: "left", 
    Cell: ({ value }) => (
      <div style={{ maxWidth: "350px", whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.4" }}>
        {value ?? "-"}
      </div>
    ),
  },
  { Header: "Response Code", accessor: "responseCode", align: "left", Cell: ({ value }) => value ?? "-" },
  { Header: "Txn ID", accessor: "txnId", align: "left", Cell: ({ value }) => value ?? "-" },
  { Header: "Vendor ID", accessor: "vendorId", align: "left", Cell: ({ value }) => value ?? "-" },
  { Header: "Txn Reference", accessor: "txnReference", align: "left", Cell: ({ value }) => value ?? "-" },
  { Header: "Void Status", accessor: "voidStatus", align: "left", Cell: ({ value }) => value ?? "-" },
];
/* eslint-enable react/prop-types */

function TransactionsDialog({ open, onClose, transactions, settlementRecord }) {
  const transactionRows = Array.isArray(transactions) ? transactions : [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogTitle>
        Transactions for Voucher No: {settlementRecord?.voucherNo ?? "N/A"}
      </DialogTitle>
      <DialogContent>
        <MDBox mt={2}>
          {transactionRows.length === 0 ? (
            <MDBox textAlign="center" py={3}>
              No transactions found for this settlement record.
            </MDBox>
          ) : (
            <DataTable
              table={{ columns: transactionColumns, rows: transactionRows }}
              showTotalEntries={true}
              isSorted={true}
              noEndBorder
              entriesPerPage={true}
              canSearch={true}
            />
          )}
        </MDBox>
      </DialogContent>
      <DialogActions>
        <MDButton color="secondary" onClick={onClose}>
          Close
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

TransactionsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  transactions: PropTypes.array,
  settlementRecord: PropTypes.object,
};

TransactionsDialog.defaultProps = {
  transactions: [],
  settlementRecord: null,
};

export default TransactionsDialog;
